module.exports = __webpack_public_path__ + "static/media/tension_clamp.badc8209.webp";